import styled from "styled-components";

export const Container = styled.div`
  width: 95%;
  margin: 0 auto;
  background: #ffffff;
  padding: 0 0 2rem 0;

  @media (min-width: 1600px) {
    max-width: 1520px;
  }

  @media (min-width: 1360px) and (max-width: 1600px) {
    max-width: 1320px;
  }

  @media (max-width: 1360px) {
    max-width: 1100px;
  }
`;

export const Form = styled.form`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 8px;
`;

export const SearchBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 8px;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const SearchBar = styled.input`
  width: 100%;
  display: block;
  margin: 12px auto;
  font-size: 18px;
  padding: 6px 4px;
`;

export const SearchButton = styled.button`
  width: fit-content;
  margin: auto;
  padding: 8.5px 16px;
  font-size: 18px;
  background: #eee;
  transition: linear 1s;
  border: solid 0.5px #999;
  border-radius: 6px;
  cursor: pointer;

  :hover {
    transition: linear 1s;
    background: #ddd;
  }
`;

export const SearchOptions = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const SelectTitle = styled.div`
  font-size: var(--font-subtitle-size);
  font-weight: 500;
  margin: 4px auto;
  text-align: center;
`;

export const Select = styled.select`
  margin: auto;
  width: 35%;
  padding: 8px 12px;
  font-size: var(--font-subtitle-size);
`;

export const Table = styled.table`
  width: 100%;
  margin: 12px auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: solid 1px #aaa;
  border-radius: 6px;
  overflow-x: auto;
`;

export const Line = styled.tr`
  display: grid;
  grid-template-columns: 1.2fr 2.2fr 2.8fr 1.6fr 1.6fr 1.6fr 1.2fr 1.2fr;
  width: 100%;
  transition: linear 0.25s;

  :nth-child(odd) {
    background: #d4d4d4;
  }

  :nth-child(even) {
    background: #c8c8c8;
  }

  :hover {
    background: #bababa;
  }
`;

export const Item = styled.td`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 4px;
  font-size: calc(1.05 * var(--font-text-size));

  :nth-child(2) {
    justify-content: left;
    margin: 4px;
  }

  :nth-child(3) {
    justify-content: left;
    margin: 4px;
  }
`;

export const Space = styled.div`
  padding: 24px;
`;

export const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  height: 100%;
`;

export const ActionsBar = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 8px 0;
`;
